/*
 * @Author: 玄离 “hongyuanzhong@cai-inc.com“
 * @Date: 2024-06-12 14:46:53
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-06-14 14:23:34
 * @FilePath: /zcy-claim-front/src/utils/aplus_queue.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { mpSdk } from '@zcy/zlb-utils';

export default async function us_aplus_queue({ page_id, page_name, page_url }) {
  const can_use = window.aplus_queue && mpSdk.env.isZzd;
  if (can_use && !mpSdk.env.isZlb) {
    const userInfo_zzd = mpSdk.env.isZlb ? await mpSdk.getAuthCode() : { code: 196729 };

    const aplus_queue = window.aplus_queue;
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_hold', 'BLOCK'],
    });
    //页面pv事件埋点
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [
        {
          is_auto: false,
        },
        {
          sapp_id: '46483', //isv根据实际填写自己应用的参数
          sapp_name: 'digital-finance-manage01', //isv根据实际填写自己应用的参数
          //自定义PV参数key-value键值对，以下内容必填，根据应用实际情况设置。
          page_id, //isv根据实际填写自己应用的参数
          page_name, //isv根据实际填写自己应用的参数
          page_url, //isv根据实际填写自己应用的参数
        },
      ],
    });
    //_user_id为会员ID
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_user_id', userInfo_zzd?.code || userInfo_zzd?.auth_code], //用户id需要埋政钉用户真实信息
    });
    //因为采集用户信息是异步行为，故需要先设置BLOCK，再设置START
    //设置_hold=START后，事先被block住的日志会携带上用户信息逐条发出
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_hold', 'START'],
    });
  }
}
